import { authedApiInstance } from '../firebase';

export const fetchThemes = async () => authedApiInstance.get('/themes').catch((error) => error?.response?.data);
